import type { DocumentPickerAsset } from 'expo-document-picker'; // File Type in native
import match from 'mime-match';
import { ACCEPT_ALL } from '../const';
import getFileNameAndExtension from './getFileNameAndExtension';

export const isFileTypeAllowed = (accept: string, file: File | DocumentPickerAsset) => {
  if (accept === ACCEPT_ALL) return true;

  const fileType = (file as File)?.type ?? (file as DocumentPickerAsset)?.mimeType;

  // ref https://github.com/transloadit/uppy/blob/7599f3abcbd8ff4602be465af5667c23345c9556/packages/%40uppy/core/src/Restricter.js#L44
  const hasMatch = accept.split(',').some((_type) => {
    const type = _type.trim();
    if (type.includes('/')) {
      if (!fileType) return false;
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call -- safe to call replace
      return match(fileType.replace(/;.*?$/, ''), type);
    }
    const { extension } = getFileNameAndExtension(file.name);
    if (type.startsWith('.') && extension) {
      return extension.toLowerCase() === type.slice(1).toLowerCase();
    }

    return false;
  });
  return Boolean(hasMatch);
};
